import axios from 'axios';

// Crear una instancia de axios simplificada 
const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000'
});

// Interceptor de solicitud simplificado
api.interceptors.request.use(
    (config) => {
        // Obtener token del almacenamiento local
        const userInfo = localStorage.getItem('userInfo');
        let token = null;
        
        if (userInfo) {
            try {
                token = JSON.parse(userInfo).token;
                if (token) {
                    config.headers['Authorization'] = `Bearer ${token}`;
                }
            } catch (e) {
                console.error('Error al parsear userInfo:', e);
            }
        }
        
        // Para FormData, no establecer Content-Type
        if (config.data instanceof FormData) {
            delete config.headers['Content-Type'];
        }
        
        return config;
    },
    (error) => Promise.reject(error)
);

// Interceptor de respuesta
api.interceptors.response.use(
    (response) => response,
    (error) => Promise.reject(error)
);

export default api; 